module.exports = __webpack_public_path__ + "img/max-600x600.5a6619c8.png";